import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-suspended-installer',
    templateUrl: './suspended-installer.component.html',
    styleUrls: ['./suspended-installer.component.scss'],
    standalone: false
})
export class SuspendedInstallerComponent {
  @Input() public isInstallerSuspended: boolean;
}
